import React, { useEffect, useState } from 'react';
import TsrTooltip from '../../tooltip';
import TsrSvgIcon from '../../assets/icons';
import { Label } from '../Label';
import { uniqueId } from 'lodash';
import { MaskName } from '../models/MaskName';
import { InputPropsBase } from '../interfaces/Inputs';
import { TextType } from '../models/TextType';
import { InputContainer } from '../InputContainer';
import './styles.scss';
import { Underline } from '../Underline';
import { TooltipType } from '../models/TooltipType';
export interface TextAreaProps extends InputPropsBase<string | number, string | number> {
    mask?: MaskName;
    type?: TextType;
    password?: boolean;
    textAreaRows?: number;
}

export const TextArea = (props: React.PropsWithChildren<TextAreaProps>) => {
    const id = uniqueId('idTextArea-');
    const [text, setText] = useState(props.value || '');
    const onBlur = () => {
        props.onBlur && props.onBlur(props.value);
    };

    useEffect(() => {
        setText(props.value);
    }, [props.value]);

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setText(value);
        props.onChange?.(value);
    };

    return (
        <InputContainer
            gap={props.gap}
            justify={props.justify}
            align={props.align}
            className={props.type === TextType.SearchBox ? 'searchbox' : ''}
            overflow={props.overflow}
        >
            <Label
                id={props.id || id}
                content={props.label}
                disabled={props.disabled === true}
                labelPosition={props.labelPosition}
                labelLength={props.labelLength}
            >
                <div
                    className={'tsr-input-textArea' + (props.className ? ' ' + props.className : '')}
                    style={{ flex: props.inputLength || 1 }}
                >
                    <textarea
                        disabled={props.disabled === 'inputOnly' || props.disabled === true}
                        value={text}
                        placeholder={props.placeholder}
                        className={props.disabled === 'inputOnly' || props.disabled === true ? 'disabled' : ''}
                        autoComplete="new-password"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        id={props.id}
                        onClick={props.onClick}
                        onChange={onChange}
                        onBlur={onBlur}
                        rows={props.textAreaRows ? props.textAreaRows : 5}
                    />
                    {props.children}
                    {props.errorMessage && !props.disabled ? (
                        <TsrTooltip type={TooltipType.Error} icon={true} content={props.errorMessage}>
                            <TsrSvgIcon icon="information" color="error" pointer />
                        </TsrTooltip>
                    ) : props.infoMessage && !props.disabled ? (
                        <TsrTooltip icon={true} content={props.infoMessage}>
                            <TsrSvgIcon icon="information" color="info" pointer />
                        </TsrTooltip>
                    ) : (
                        props.infoMessage && <TsrSvgIcon icon="information" color="disabled" />
                    )}
                    <Underline disabled={props.disabled === 'inputOnly' || props.disabled === true} />
                </div>
            </Label>
        </InputContainer>
    );
};
